import { render, staticRenderFns } from "./DocumentoIPSign.vue?vue&type=template&id=5a3e6e60&"
import script from "./DocumentoIPSign.vue?vue&type=script&lang=js&"
export * from "./DocumentoIPSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports